<div class="RegPage"  >




<div class="container" style="margin-bottom:50px;height:350px;">

<div class="Clears"></div>
<!-- <div class="row">
    <div class="row"  *ngIf="!Motor">
        <div class="Description">
            <p>Car owners should be keen to possess “Third-Party Liability Motor Insurance Policy – Motor Insurance” in which will offer them coverage of any Third-Party Liabilities that may occur in the event of experiencing car accidents in addition to any resulting property damages or physical injuries or death, thus it’s profound for both car owners and drivers to possess a Motor Insurance Policy that will speed up the release process of the driver causing the accident if taken in custody by police authorities (except in the event of death , God forbid).</p>
      <p>ACIG provides insurance product namely “TESLAM” to cover the civil liabilities towards third-party resulting from vehicle accidents that can be linked to the vehicle itself instead of the driver’s driving license, “TESLAM” is a Shari’ah compliant “Third-Party Liability Motor Insurance” product that is thoroughly permitted in the Saudi Arabian insurance Market.</p>
        </div>
    </div>

    <div class="Clears"></div>
        <div class="InsuranceModels" *ngIf="!Motor">
            <div class="row">
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
                <div class="col-lg-8 col-md-5 col-sm-8 col-xs-8">
                  <div class="ModelsList">
                    <div class="row">
                      <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <div class="Motor ListMd"  data="Motor"    (click)="Motors()">
                            <img src="assets/theme/en/images/product_icon_07.png" alt="Motor">
                            <p>Motor TPL</p>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <div class="Comprehensive ListMd" data="Comprehensive"   (click)="Comprehensive()">
                            <img src="assets/theme/en/images/product_icon_06.png">
                            <p>Motor Comprehensive</p>
                        </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-6">
                        <div class="MedMal ListMd"  data="Medical"  (click)="Medical()">
                            <img src="assets/theme/en/images/product_icon_05.png">
                            <p>Medical  Insurance</p>
                        </div>
                          </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
              </div>
        </div>
      </div> -->
<div class="Motor"  >

       <p> Car owners should be keen to possess “Third-Party Liability Motor Insurance Policy – Motor Insurance” in which will offer them coverage of any Third-Party Liabilities that may occur in the event of experiencing car accidents in addition to any resulting property damages or physical injuries or death, thus it’s profound for both car owners and drivers to possess a Motor Insurance Policy that will speed up the release process of the driver causing the accident if taken in custody by police authorities (except in the event of death , God forbid).
       
        </p>
        <div class="Clears"></div>
        <p>ACIG provides insurance product namely “TESLAM” to cover the civil liabilities towards third-party resulting from vehicle accidents that can be linked to the vehicle itself instead of the driver’s driving license, “TESLAM” is a Shari’ah compliant “Third-Party Liability Motor Insurance” product that is thoroughly permitted in the Saudi Arabian insurance Market.</p>
        <div class="Clears"></div>
        <div class="Clears"></div>
        <div class="Clears"></div>
        <div class="row">

                <div class="col-lg-4 col-sm-4 hidden-xs hidden-sm">
                        <img class="img-responsive imgcustom"  src="assets/theme/en/images/product_icon_03.png">
                        <img class="img-responsive imgcustom"  src="assets/theme/en/images/product_icon_01.png">
                        <img class="img-responsive imgcustom"  src="assets/theme/en/images/product_icon_02.png">
                       
                </div>
            <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                    <!-- <div class="row" *ngIf="Motor">
                            <span class="DriverLicenseDate">{{SelectedType}}</span>
                        </div> -->
                        <!-- <div class="Clears"></div>
                        <span class="FormTitle">Insured Information</span>
                        <div class="Clears"></div> -->
                 <div class="InsuredInformation Infomation">
                     <div class="Headertitle">
                         <span>Insured Information</span>
                         <img src="assets/theme/en/images/product_icon_07.png">
                     </div>
                       <!-- <div class="row">
                                     <span class="TypeSelected">{{SelectedType}}</span>
                                 </div> -->
                     <div class="FormSection">
                             <!-- <div class="row">
                                     <span class="DriverLicenseDate">Insured Information</span>
                                 </div> -->
                                 <div class="Clears"></div>

                                
                         <div class="Field">
                             <div class="row">
                                 <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                     <label class="Iqama">Identification / Iqama Number</label>
                                 </div>
                                 <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                     <input type="text" class="form-control" [(ngModel)]="RegObj.IqamaNo" [attr.disabled]="PolicyTrue?'true':null" (change)="ValidateIqama($event)">
                                     </div>
                             </div>
                         </div>
 
                         <div class="Field" *ngIf="DobRequired">
                                 <div class="row">
                                     <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                         <label>Date of Birth</label>
                                     </div>
                                     <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                             <div class=" row dobfiled">
                                                     <div class="col-lg-3">
                                                      
                                                       <input class="form-control" [attr.disabled]="PolicyTrue?'true':null" placeholder="DD" type="text">
                                                     </div>
                                                     <div class="col-lg-3">
                                                            
                                                             <input class="form-control" [attr.disabled]="PolicyTrue?'true':null" placeholder="MM" type="text">
                                                           </div>
                                                           <div class="col-lg-3">
                                                            
                                                                 <input class="form-control" [attr.disabled]="PolicyTrue?'true':null" placeholder="YYYY" type="text">
                                                               </div>
     
                                          </div>
                                                 
                                 </div>
                             </div>
                         </div>

                         <!-- <div class="Field">
                                <div class="row">
                                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                        <label>Seqence No</label>
                                    </div>
                                    <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                       <input type="text" [attr.disabled]="PolicyTrue?'true':null" [(ngModel)]="RegObj.Email" placeholder="Email Id" class="form-control">
                                        </div>
                                </div>
                            </div> -->
                             <div class="Field">
                                     <div class="row">
                                         <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                             <label>Email Id</label>
                                         </div>
                                         <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                            <input type="text" [attr.disabled]="PolicyTrue?'true':null" [(ngModel)]="RegObj.Email" placeholder="Email Id" class="form-control">
                                             </div>
                                     </div>
                                 </div>
 
                                 <div class="Field">
                                         <div class="row">
                                             <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                 <label>Mobile</label>
                                             </div>
                                             <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                  <input type="text" [attr.disabled]="PolicyTrue?'true':null" [(ngModel)]="RegObj.Mobile" placeholder="Mobile" class="form-control">
                                                 </div>
                                         </div>
                                     </div>
 
                                     <div class="Field">
 
                                             <div class="checkbox checkbox-primary">
                                                     <input id="checkbox2" type="checkbox"  >
                                                     <label for="checkbox2" [attr.disabled]="PolicyTrue?'true':null">
                                                             I hereby give ACIG advance consent to obtain information of me and/or any vehicle under my ownership from the National Information Center.
                                                     </label>
                                                 </div>
                                                                     
                                           
                                     </div>
 
                                    
                     </div>
 
 
                     <!-- Second Form Section -->
 
                     <div class="OTPForm" *ngIf="OTP">
                             <div class="Field">
                                     <div class="row">
                                         <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                             <label>Verification Code</label>
                                         </div>
                                         <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                             
 
                                              <div class="row">
                                                  <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                                                         <input type="text" placeholder="Verification Code" [(ngModel)]="RegObj.OTP" class="form-control">
                                                  </div>
                                                  <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                                      <input type="button" class="btn btn-primary Resend" value="Resend">
                                                     </div>
                                              </div>
                                             </div>
                                     </div>
                                 </div>
                     </div>
 

                  
                   
 <!-- Button Actions -->
 
 <div class="Actionsection" *ngIf="!Vehicle">
         <div class="Actions">
                 <div class="btn-group">
                        <!-- <button type="button" class="btn btn-primary btns" [attr.disabled]="PolicyTrue?'true':null" (click)="Back()">Back</button> -->
                                 <button type="button" class="btn btn-primary btns" [attr.disabled]="PolicyTrue?'true':null" (click)="Next()">Proceed</button>
                                 
                             </div>
         </div>
 </div>
                     
                     </div>
            </div>
<div class="col-lg-4 col-sm-4 hidden-xs hidden-sm">
        <img class="img-responsive imgcustom1"  src="assets/theme/en/images/product_icon_04.png">
        <img class="img-responsive imgcustom1"  src="assets/theme/en/images/product_icon_05.png">
        <img class="img-responsive imgcustom1"  src="assets/theme/en/images/product_icon_06.png">
</div>

            <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <div class="Clears"></div>
                        <span class="FormTitle">Policy Information</span>
                        <div class="Clears"></div>
                        <div class="InsuredInformation Infomation">
                              
                              <div class="FormSection">
                                    
                                          <div class="Clears"></div>
                
                                          <div class="Field">
                                                 <div class="row">
                                                     <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                         <label>Policy Type</label>
                                                     </div>
                                                     <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                            <select [attr.disabled]="!PolicyTrue?'true':null" class="form-control" [(ngModel)]="AddNewPolicyObj.PolicyType">
                                                          
                                                          <option value="5515" >Third Party Liability Insurance</option>
                                                          <option value="5520" >Comprehensive Insurance</option>
                                                          <option value="0000">Motor Insurance</option>
                                                                </select>
                                                         </div>
                                                 </div>
                                             </div>
                                  <div class="Field">
                                      <div class="row">
                                          <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                              <label>Vehicle Definition Type</label>
                                          </div>
                                          <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                <select class="form-control" [attr.disabled]="!PolicyTrue?'true':null" [(ngModel)]="AddNewPolicyObj.VehicleDefionitionType">
                                                        <option value="2" >Sequence No</option>
                                                          <option value="3">Customer Id</option>
                                                         
                                                    </select>
                                              </div>
                                      </div>
                                  </div>
                
                                  <div class="Field">
                                          <div class="row">
                                              <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                  <label>Iqama No</label>
                                              </div>
                                              <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                    <input class="form-control" disabled  placeholder="Iqama No" type="text" [(ngModel)]="AddNewPolicyObj.IqamaNo" disabled>
                                                      
                                                          
                                          </div>
                                      </div>
                                  </div>
                
                                
                               
                                          
                                  <div class="Field"   *ngIf="AddNewPolicyObj.VehicleDefionitionType==2">
                                        <div class="row">
                                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                <label>Sequence No</label>
                                            </div>
                                            <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                  <input class="form-control" placeholder="Sequence No" type="text"  [(ngModel)]="AddNewPolicyObj.SequenceNo">
                                                    
                                                        
                                        </div>
                                    </div>
                                </div>
                
                                
                
                                <div class="Field" *ngIf="AddNewPolicyObj.VehicleDefionitionType==3">
                                        <div class="row">
                                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                <label>Customer Id</label>
                                            </div>
                                            <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                  <input class="form-control" placeholder="Customer Id" type="text" [(ngModel)]="AddNewPolicyObj.CustomerId" >
                                                    
                                                        
                                        </div>
                                    </div>
                                </div>
                                      
                                <div class="Field" class="Field" *ngIf="AddNewPolicyObj.VehicleDefionitionType==3">
                                        <div class="row">
                                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                <label>Custom ID Issuence Date</label>
                                            </div>
                                            <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                  <input class="form-control" placeholder="Custom ID Issuence Date" type="text" [(ngModel)]="AddNewPolicyObj.CustomerIssueDate" >
                                                    
                                                        
                                        </div>
                                    </div>
                                </div>

                                <div class="Field">
                                        <div class="row">
                                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                               
                                            </div>
                                            <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                    <label class="transfer"><input type="checkbox" [attr.disabled]="!PolicyTrue?'true':null" (change)="checked($event)"/>Transfer of OwnerShip</label>
                                                    
                                                        
                                        </div>
                                    </div>
                                </div>
                
                                <div class="Field" *ngIf="AddNewPolicyObj.Transfer">
                                        <div class="row">
                                            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                                <label>Owner Iqama No</label>
                                            </div>
                                            <div class="col-lg-9 col-md-9 col-sm-6 col-xs-12">
                                                  <input class="form-control" placeholder="Owner Iqama No" type="text"  [(ngModel)]="AddNewPolicyObj.OwnerIqamaNo">
                                                    
                                                        
                                        </div>
                                    </div>
                                </div>
                                             
                              </div>
                
                 
                
                
                           
                            
              
                
                <div class="Actionsection" >
                  <div class="Actions">
                          <div class="btn-group">
                                 
                                          <button type="button" class="btn btn-primary btns" [attr.disabled]="!PolicyTrue?'true':null" (click)="Proceed()">Proceed</button>
                                          
                                      </div>
                  </div>
                </div>
                <div class="Clears"></div>
                
                              </div>
                
                
                
                             
                
                              
                
                                <div class="Clears"></div>
                
        </div> -->
           
 
          
        </div>
         
 
        
        
 </div>
 
 
</div>

</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Register/Register.html